import React, { useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Assignment, Visibility } from '@material-ui/icons';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';

import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService';
import Filter from 'components/Tvendo/Common/FilterCustom';

import ModalMarkedDay from './Modal/ModalMarkedDay';
import { Box } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Zona', accessor: 'zone' },
  { Header: 'Ruta', accessor: 'route' },
  { Header: 'Clientes marcados', accessor: 'marked' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function MarkedDay(props) {
  const classes = useStyles();

  const [showModalMarkedDay, setShowModalMarkedDay] = useState(false); //Abrir modal
  const [route, setRoute] = useState(null);

  const [dataLoading, setDataLoading] = useState(false);
  const [markedDays, setMarkedDays] = useState([]);
  const [date, setDate] = useState({});

  async function getMarkeds(search) {
    setDate({ start_date: search.start_date, end_date: search.end_date });
    if (search) {
      search = {
        base_zone_id: search.base_zone_id,
        start_date: search.start_date,
        end_date: search.end_date
      };
    }

    for (var clave in search) {
      if (search[clave] == null) {
        delete search[clave]; //eliminamos solo las claves vacias
      }
    }
    setDataLoading(true);
    let response = await wsFindBy('base/customer-route/marked-of-day', search);
    setDataLoading(false);
    if (response.success) {
      setMarkedDays(response.data);
    }
  }

  return (
    <>
      <ModalMarkedDay
        showModalMarkedDay={showModalMarkedDay}
        setShowModalMarkedDay={setShowModalMarkedDay}
        route={route}
        date={date}
      />
      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Listado de puntos por día {dataLoading && <LoadingSpinner />}</h4>
        </CardHeader>
        <CardBody>
          <Filter getFilter={getMarkeds} zone dateRange />
          <ReactTable
            excelName="puntos-por-dia"
            defaultWidth={1000}
            indexRow={[0, 3, 4]}
            widthRow={[100, 180, 10]}
            columns={columns}
            data={markedDays.map((marked, i) => {
              return {
                num: (
                  <Box display="flex" alignItems="center">
                    {i + 1}
                    <AllowedGuard
                      permission={ConstantPermissions.BASE_CUSTOMER_ROUTES_MARKED_OF_DAY_DETAIL}
                    >
                      <Button
                        justIcon
                        round
                        simple
                        color="primary"
                        className="like"
                        onClick={() => {
                          setShowModalMarkedDay(true);
                          setRoute(marked);
                        }}
                      >
                        <Visibility />
                      </Button>
                    </AllowedGuard>
                  </Box>
                ),
                zone: marked.zone_code,
                route: marked.route_description,
                marked: marked.marked,
                actions: ''
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
